export default __webpack_public_path__ + "static/media/MM6B_JS6B.7bca31fd.jpg";